<ng-container *ngIf="rows.length">
  <div class="d-flex align-items-center mb-1">
    <h6 class="mb-0">Tutar karşılaştırması</h6>
    <span class="badge bg-success ms-2" *ngIf="!hasMismatch()">Tutarlar uyumlu</span>
    <span class="badge bg-danger ms-2" *ngIf="hasMismatch()">Fark var</span>
  </div>
  <div class="table-responsive mb-3">
    <table class="table table-sm table-bordered align-middle mb-0">
      <thead class="table-light">
        <tr>
          <th></th>
          <th class="text-end">Gönderilen</th>
          <th class="text-end">Cevaptaki</th>
          <th class="text-end">Fark</th>
          <th class="text-center" style="width: 1%"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of rows" [class.table-danger]="difference(row) !== null && !isMatch(row)">
          <td>{{ row.label }}</td>
          <td class="text-end">{{ format(row, row.requested) }}</td>
          <td class="text-end">{{ format(row, row.responded) }}</td>
          <td class="text-end">
            <ng-container *ngIf="difference(row) !== null && !isMatch(row); else noDifference">
              {{ difference(row)! > 0 ? '+' : '' }}{{ format(row, difference(row)!) }}
            </ng-container>
            <ng-template #noDifference><span class="text-muted">—</span></ng-template>
          </td>
          <td class="text-center">
            <i class="bx bx-check text-success fs-5" *ngIf="isMatch(row)" title="Aynı"></i>
            <i class="bx bx-error text-danger fs-5" *ngIf="difference(row) !== null && !isMatch(row)" title="Farklı"></i>
            <span class="text-muted small" *ngIf="difference(row) === null" title="Bir tarafta yok">—</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-container>
